import React from 'react';
import PropTypes from 'prop-types';

// Styled.
import * as S from './styled';

const TabGroup = ({ links }) => (
  <S.Tabs>
    {links.map(({ name, to, isActive }) => (
      <S.Item key={name} to={to} selected={isActive}>
        {name}
      </S.Item>
    ))}
  </S.Tabs>
);

TabGroup.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
    }),
  ),
};

export default TabGroup;
